import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

const reviews = [
  {
    name: '张先生',
    avatar: 'ri-user-3-line',
    rating: 5,
    text: '6080电影网真的太好用了！看电影完全不卡，也没有烦人的广告弹窗，高清画质真的赞。推荐给所有喜欢看电影的朋友！',
    date: '2024-06-15',
  },
  {
    name: '李女士',
    avatar: 'ri-user-3-line',
    rating: 5,
    text: '用了快一年了，资源更新速度真的快，基本上影院下映不久就能在6080电影网上看到高清版本。免费高清电影在线看，太良心了。',
    date: '2024-05-28',
  },
  {
    name: '王同学',
    avatar: 'ri-user-3-line',
    rating: 5,
    text: '作为一名大学生，6080电影网是我课余时间最好的陪伴。电影资源丰富，分类清晰，找片特别方便。高清不缓冲，体验一级棒。',
    date: '2024-05-10',
  },
  {
    name: '赵先生',
    avatar: 'ri-user-3-line',
    rating: 4,
    text: '朋友推荐来的，用了之后确实不错。清晰度高，加载速度快，免费高清影视资源很全。希望6080电影网越来越好！',
    date: '2024-04-22',
  },
  {
    name: '孙女士',
    avatar: 'ri-user-3-line',
    rating: 5,
    text: '家庭影院必备网站！周末带着孩子一起看动画电影，画质清晰流畅。极速秒开的体验真的没话说，强烈推荐！',
    date: '2024-04-08',
  },
  {
    name: '周先生',
    avatar: 'ri-user-3-line',
    rating: 5,
    text: '作为电影发烧友，6080电影网的资源库真的让我惊喜。从经典老片到最新大片，应有尽有。无广告的观影体验太舒服了。',
    date: '2024-03-18',
  },
];

const faqs = [
  {
    question: '6080电影网需要注册才能观看吗？',
    answer: '不需要！6080电影网所有电影均可免费在线观看，无需注册、无需登录，打开即可享受高清电影免费观看体验。',
  },
  {
    question: '6080电影网的视频清晰度如何？',
    answer: '我们提供高清画质（720P/1080P），部分热门电影支持超清4K画质。采用先进的视频编码技术，确保最佳观影体验。',
  },
  {
    question: '观看电影时为什么会偶尔出现缓冲？',
    answer: '一般不会出现缓冲。如果偶有缓冲，可能是网络环境不稳定导致的。建议检查网络连接或切换至流畅画质。我们的CDN加速网络覆盖全球，确保极速秒开的观影体验。',
  },
  {
    question: '6080电影网可以在手机上观看吗？',
    answer: '当然可以！6080电影网完美适配手机、平板和电脑等各种设备。无论您在哪里，都能享受免费电影在线看的乐趣。',
  },
  {
    question: '你们会定期更新新电影吗？',
    answer: '是的，我们的内容团队每天都会更新最新的高清电影资源。影院下映的电影通常会在较短时间内上架，确保用户能够及时看到最新电影免费在线观看。',
  },
];

export default function AboutPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    phone_alt: '',
  });
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotValue = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim() || '';
    if (honeypotValue) {
      setSubmitStatus('success');
      setFormData({ name: '', email: '', message: '', phone_alt: '' });
      setTimeout(() => setSubmitStatus('idle'), 3000);
      return;
    }

    setSubmitStatus('loading');
    setFormError('');

    try {
      const fd = new FormData(form);
      fd.delete('phone_alt');
      const response = await fetch('https://readdy.ai/api/form/d9njq24it35ii3jdlsa0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', message: '', phone_alt: '' });
        setTimeout(() => setSubmitStatus('idle'), 3000);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '提交失败，请稍后重试';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setSubmitStatus('success');
          setFormData({ name: '', email: '', message: '', phone_alt: '' });
          setTimeout(() => setSubmitStatus('idle'), 3000);
        } else {
          setSubmitStatus('error');
          setFormError(serverMsg);
        }
      }
    } catch {
      setSubmitStatus('error');
      setFormError('网络错误，请稍后重试');
    }
  };

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20">
          {/* Breadcrumb */}
          <div className="px-4 md:px-6 lg:px-8 py-4">
            <div className="max-w-5xl mx-auto">
              <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
            </div>
          </div>

          {/* Brand Intro */}
          <section className="px-4 md:px-6 lg:px-8 py-12 md:py-16">
            <div className="max-w-3xl mx-auto text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-primary-500/20 rounded-2xl mx-auto mb-6">
                <i className="ri-movie-2-fill text-primary-500 text-3xl"></i>
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-50 font-heading mb-4">
                关于<strong className="text-primary-500">6080电影网</strong>
              </h1>
              <p className="text-foreground-400 text-sm md:text-base leading-relaxed max-w-2xl mx-auto">
                6080电影网成立于2020年，是一个致力于提供<strong>高清电影免费在线观看</strong>服务的平台。
                我们汇聚了海量<strong>免费高清影视</strong>资源，从最新上映的热门大片到经典老片，覆盖动作、喜剧、科幻、爱情、恐怖等多种类型。
                依托全球CDN加速网络和先进的视频编码技术，我们的平台实现了<strong>极速秒开</strong>、<strong>高清不缓冲</strong>的极致观影体验，
                并且全程<strong>无广告</strong>干扰，让每一位影迷都能沉浸在纯粹的电影世界中。
              </p>
            </div>
          </section>

          {/* Features Grid */}
          <section className="px-4 md:px-6 lg:px-8 py-10 bg-background-100">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-2xl font-bold text-foreground-50 text-center mb-10 font-heading">
                我们的优势
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                <div className="p-5 rounded-xl bg-background-50 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/20 mx-auto mb-3">
                    <i className="ri-hd-line text-primary-500 text-xl"></i>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-50 mb-1">真高清画质</h3>
                  <p className="text-xs text-foreground-400">720P/1080P高清画质，部分支持4K超清</p>
                </div>
                <div className="p-5 rounded-xl bg-background-50 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/20 mx-auto mb-3">
                    <i className="ri-flashlight-line text-accent-500 text-xl"></i>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-50 mb-1">极速秒开</h3>
                  <p className="text-xs text-foreground-400">全球CDN加速，即点即看无需等待</p>
                </div>
                <div className="p-5 rounded-xl bg-background-50 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-500/20 mx-auto mb-3">
                    <i className="ri-close-circle-line text-secondary-500 text-xl"></i>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-50 mb-1">零广告</h3>
                  <p className="text-xs text-foreground-400">全程无广告干扰，纯净观影体验</p>
                </div>
                <div className="p-5 rounded-xl bg-background-50 text-center">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/20 mx-auto mb-3">
                    <i className="ri-refresh-line text-accent-500 text-xl"></i>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-50 mb-1">每日更新</h3>
                  <p className="text-xs text-foreground-400">最新电影及时上架，资源丰富</p>
                </div>
              </div>
            </div>
          </section>

          {/* Stats */}
          <section className="px-4 md:px-6 lg:px-8 py-12">
            <div className="max-w-5xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
                <div>
                  <div className="text-3xl md:text-4xl font-bold text-accent-500 font-heading">20000+</div>
                  <p className="text-sm text-foreground-400 mt-2">高清电影资源</p>
                </div>
                <div>
                  <div className="text-3xl md:text-4xl font-bold text-primary-500 font-heading">10+</div>
                  <p className="text-sm text-foreground-400 mt-2">电影分类</p>
                </div>
                <div>
                  <div className="text-3xl md:text-4xl font-bold text-accent-500 font-heading">500万+</div>
                  <p className="text-sm text-foreground-400 mt-2">日活跃用户</p>
                </div>
                <div>
                  <div className="text-3xl md:text-4xl font-bold text-primary-500 font-heading">99.9%</div>
                  <p className="text-sm text-foreground-400 mt-2">服务可用率</p>
                </div>
              </div>
            </div>
          </section>

          {/* Reviews */}
          <section className="px-4 md:px-6 lg:px-8 py-10 bg-background-100">
            <div className="max-w-5xl mx-auto">
              <h2 className="text-2xl font-bold text-foreground-50 text-center mb-10 font-heading">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {reviews.map((review, i) => (
                  <div key={i} className="p-5 rounded-xl bg-background-50">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100">
                        <i className={`${review.avatar} text-foreground-400`}></i>
                      </div>
                      <div>
                        <p className="text-sm font-semibold text-foreground-50">{review.name}</p>
                        <div className="flex items-center gap-0.5 mt-0.5">
                          {Array.from({ length: 5 }).map((_, j) => (
                            <i
                              key={j}
                              className={`ri-star-fill text-xs ${j < review.rating ? 'text-accent-500' : 'text-foreground-600'}`}
                            ></i>
                          ))}
                        </div>
                      </div>
                    </div>
                    <p className="text-sm text-foreground-300 leading-relaxed">{review.text}</p>
                    <p className="text-xs text-foreground-500 mt-3">{review.date}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="px-4 md:px-6 lg:px-8 py-12">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl font-bold text-foreground-50 text-center mb-10 font-heading">
                常见问题
              </h2>
              <div className="space-y-3">
                {faqs.map((faq, i) => (
                  <details key={i} className="group rounded-xl bg-background-100 border border-background-200/60 overflow-hidden">
                    <summary className="flex items-center justify-between p-4 cursor-pointer text-sm font-medium text-foreground-100 list-none">
                      <span>{faq.question}</span>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-4 pb-4 text-sm text-foreground-400 leading-relaxed">
                      {faq.answer}
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="px-4 md:px-6 lg:px-8 py-12 bg-background-100">
            <div className="max-w-2xl mx-auto">
              <h2 className="text-2xl font-bold text-foreground-50 text-center mb-4 font-heading">
                联系我们
              </h2>
              <p className="text-sm text-foreground-400 text-center mb-8">
                如果您有任何问题或建议，欢迎通过以下表单与我们联系。
              </p>

              <form data-readdy-form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="contact-name" className="block text-sm text-foreground-300 mb-1.5">
                      您的姓名
                    </label>
                    <input
                      id="contact-name"
                      name="name"
                      type="text"
                      required
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-100 text-sm focus:outline-none focus:border-primary-500 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm text-foreground-300 mb-1.5">
                      电子邮箱
                    </label>
                    <input
                      id="contact-email"
                      name="email"
                      type="email"
                      required
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-100 text-sm focus:outline-none focus:border-primary-500 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="contact-message" className="block text-sm text-foreground-300 mb-1.5">
                    留言内容
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    required
                    maxLength={500}
                    rows={4}
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-100 text-sm focus:outline-none focus:border-primary-500 transition-colors resize-none"
                    placeholder="请输入您的留言内容（不超过500字）"
                  ></textarea>
                  <p className="text-xs text-foreground-500 mt-1 text-right">{formData.message.length}/500</p>
                </div>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  value={formData.phone_alt}
                  onChange={(e) => setFormData({ ...formData, phone_alt: e.target.value })}
                  className="honeypot-field"
                />
                <button
                  type="submit"
                  disabled={submitStatus === 'loading'}
                  className="w-full py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap disabled:opacity-60"
                >
                  {submitStatus === 'loading' ? (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-loader-4-line animate-spin"></i> 提交中...
                    </span>
                  ) : (
                    '提交留言'
                  )}
                </button>
                {submitStatus === 'success' && (
                  <div className="p-3 rounded-lg bg-accent-500/10 border border-accent-500/30 text-accent-400 text-sm text-center">
                    <i className="ri-check-line mr-1"></i> 提交成功！感谢您的留言，我们会尽快回复。
                  </div>
                )}
                {submitStatus === 'error' && (
                  <div className="p-3 rounded-lg bg-primary-500/10 border border-primary-500/30 text-primary-400 text-sm text-center">
                    <i className="ri-error-warning-line mr-1"></i> {formError}
                  </div>
                )}
              </form>
            </div>
          </section>
        </main>

        {/* Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'AboutPage',
              name: '关于6080电影网',
              description: '6080电影网提供高清电影免费在线观看服务，海量免费高清影视资源，极速秒开无广告。',
              publisher: { '@type': 'Organization', name: '6080电影网' },
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqs.map((faq) => ({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: { '@type': 'Answer', text: faq.answer },
              })),
            }),
          }}
        />

        <Footer />
      </div>
    </>
  );
}